module.exports = __webpack_public_path__ + "dollar-coin.7fbf8920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/coins/dollar-coin.png
// module id = 240
// module chunks = 0